import { PanelStepCheckIcon } from "@/components/icons/icons";

interface PanelStepProgressProps {
  currentStep: number;
  totalSteps: number;
  stepLabel: string;
}

export const PanelStepProgress = ({
  currentStep,
  totalSteps,
  stepLabel,
}: PanelStepProgressProps) => (
  <div className="flex flex-col gap-3 mb-6">
    {/* Step circles + connectors */}
    <div className="flex items-center">
      {Array.from({ length: totalSteps }, (_, i) => {
        const stepNum = i + 1;
        const isCompleted = stepNum < currentStep;
        const isActive = stepNum === currentStep;
        return (
          <div key={stepNum} className="flex items-center flex-1 last:flex-none">
            <div
              className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                isCompleted
                  ? "bg-white"
                  : isActive
                    ? "bg-white/30 border-2 border-white"
                    : "bg-white/10 border border-white/20"
              }`}
            >
              {isCompleted ? (
                <PanelStepCheckIcon className="text-primary-purple" />
              ) : (
                <span
                  className={`text-[9px] font-bold leading-none ${
                    isActive ? "text-white" : "text-white/40"
                  }`}
                >
                  {stepNum}
                </span>
              )}
            </div>
            {/* Connector line (not after last) */}
            {stepNum < totalSteps && (
              <div
                className={`flex-1 h-px mx-1.5 ${isCompleted ? "bg-white/60" : "bg-white/15"}`}
              />
            )}
          </div>
        );
      })}
    </div>
    {/* Step label */}
    <p className="text-[10px] font-semibold tracking-[1.1px] uppercase text-white/50">
      Step {currentStep} of {totalSteps} — {stepLabel}
    </p>
  </div>
);
